import React, { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
export default function NewsTopSection({
  TheObject,
  ListOfBrands,
  ListGiftBroducts,
}) {
  const { t, i18n } = useTranslation();
  const history = useHistory();
  console.log(TheObject);
  console.log(i18n.language);

  const [MyWidth, setMyWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setMyWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);

    // Cleanup listener on unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const scrollToTop2 = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  // Function to format the time remaining
  const formatTime = (time) => {
    if (time <= 0) return "0 Days, 0 Hours, 0 Minutes, 0 Seconds";

    const days = Math.floor(time / (1000 * 60 * 60 * 24));
    const hours = Math.floor((time / (1000 * 60 * 60)) % 24);
    const minutes = Math.floor((time / (1000 * 60)) % 60);
    const seconds = Math.floor((time / 1000) % 60);
    return `${days} ${t("profile.days")} ${t(
      "profile.and"
    )} ${hours}:${minutes}:${seconds}`;
  };

  // Function to handle image click and navigation
  const handleDivClick = (CategoryName) => {
    history.push(`${CategoryName}`);
    scrollToTop2();
  };

  // Refs and timers for the single card
  const timerRef = useRef(null);
  const displayRef = useRef(null);

  useEffect(() => {
    const startDate = new Date();
    const endDate = new Date(TheObject.dateEnd.split("-").reverse().join("-"));
    let remainingTime = endDate - startDate;

    if (displayRef.current) {
      displayRef.current.innerText = formatTime(remainingTime);
    }

    timerRef.current = setInterval(() => {
      remainingTime -= 1000;
      if (remainingTime <= 0) {
        clearInterval(timerRef.current);
        remainingTime = 0;
      }
      if (displayRef.current) {
        displayRef.current.innerText = formatTime(remainingTime);
      }
    }, 1000);

    return () => {
      clearInterval(timerRef.current);
    };
  }, [TheObject]);

  // Function to highlight brands and gift products
  const highlightBrandsAndGifts = (text, brands, giftProducts) => {
    let highlightedText = text;

    // Highlight brands in red
    if (Array.isArray(brands)) {
      brands.forEach((brand) => {
        const regex = new RegExp(`(${brand.name})`, "gi");
        highlightedText = highlightedText?.replace(
          regex,
          `<span data-codebrand="${brand.codeBrand}" data-brandname="${brand.name}" style="color: #6b21a8; cursor: pointer;">$1</span>`
        );
      });
    } else {
      console.error("ListOfBrands is not an array:", brands);
    }

    // Highlight gift products in green
    if (Array.isArray(giftProducts)) {
      giftProducts.forEach((gift) => {
        const regex = new RegExp(`(${gift.checkGiftName})`, "gi");
        highlightedText = highlightedText?.replace(
          regex,
          `<span data-giftid="${gift.id}" style="color: #6b21a8; cursor: pointer;">$1</span>`
        );
      });
    } else {
      console.error("ListGiftBroducts is not an array:", giftProducts);
    }

    return highlightedText;
  };

  // Function to handle brand clicks
  const handleBrandClick = (codeBrand, brandName) => {
    history.push({
      pathname: `/brand/${codeBrand}`, // The target URL
      state: { brandName: brandName }, // Pass the brandName as state
    });
  };
  // Function to handle gift product clicks
  const handleGiftClick = (giftId) => {
    history.push(`/product/${giftId}`);
  };

  // Highlight brands and gift products
  const highlightedText = highlightBrandsAndGifts(
    i18n.language === "en"
      ? TheObject.disc1
      : i18n.language === "ar"
      ? TheObject.disc1Ar
      : i18n.language === "he"
      ? TheObject.disc1He
      : TheObject.disc1,
    ListOfBrands || [], // Fallback to an empty array if ListOfBrands is undefined
    ListGiftBroducts || [] // Fallback to an empty array if ListGiftBroducts is undefined
  );

  // Use a ref to access the rendered HTML element
  const textRef = useRef(null);

  // Use useEffect to attach click handlers after the component mounts
  useEffect(() => {
    if (textRef.current) {
      // Find all spans with the data-codebrand attribute (brands)
      const brandSpans = textRef.current.querySelectorAll(
        "span[data-codebrand]"
      );
      brandSpans.forEach((span) => {
        span.addEventListener("click", () => {
          const codeBrand = span.getAttribute("data-codebrand");
          const brandName = span.getAttribute("data-brandname");
          handleBrandClick(codeBrand, brandName);
        });
      });

      // Find all spans with the data-giftid attribute (gift products)
      const giftSpans = textRef.current.querySelectorAll("span[data-giftid]");
      giftSpans.forEach((span) => {
        span.addEventListener("click", () => {
          const giftId = span.getAttribute("data-giftid");
          handleGiftClick(giftId);
        });
      });

      // Cleanup event listeners on unmount
      return () => {
        brandSpans.forEach((span) => {
          span.removeEventListener("click", () => {
            const codeBrand = span.getAttribute("data-codebrand");
            const brandName = span.getAttribute("data-brandname");
            handleBrandClick(codeBrand, brandName);
          });
        });

        giftSpans.forEach((span) => {
          span.removeEventListener("click", () => {
            const giftId = span.getAttribute("data-giftid");
            handleGiftClick(giftId);
          });
        });
      };
    }
  }, [highlightedText]);

  // const isDateAfterToday = (dateStr) => {
  //   const today = new Date();
  //   const formattedDate = `${String(today.getDate()).padStart(2, "0")}-${String(
  //     today.getMonth() + 1
  //   ).padStart(2, "0")}-${today.getFullYear()}`;

  //   return TheObject.dateEnd >= formattedDate;
  // };

  // // const parseDate = (dateStr) => {
  // //   const [day, month, year] = dateStr.split("-").map(Number);
  // //   return new Date(year, month - 1, day); // month is 0-indexed
  // // };
  // const isAfter = isDateAfterToday(TheObject.dateEnd); // returns true or false
  const isDateAfterToday = (dateStr) => {
    const [day, month, year] = dateStr.split("-").map(Number);
    const inputDate = new Date(year, month - 1, day);

    const today = new Date();
    today.setHours(0, 0, 0, 0); // set to midnight to ignore time differences

    return inputDate > today;
  };

  // Example:
  const isAfter = isDateAfterToday(TheObject.dateEnd); // returns true or false

  return (
    <div
      style={{
        display: "flex",
        width: "100%",
        justifyContent: isAfter ? "space-evenly" : "center",
        flexDirection: MyWidth <= 768 ? "column" : isAfter ? "row" : "column",
        paddingBottom: 45,
        alignItems: isAfter ? "" : "center",
      }}
    >
      <div
        style={{
          width: MyWidth <= 768 ? "100%" : "45%",
          height: "100%",
          display: "flex",
        }}
      >
        <img
          src={TheObject.image}
          alt="Expand"
          style={{ width: "100%", height: "100%" }}
        />
      </div>
      <div
        style={{
          width: MyWidth <= 768 ? "100%" : "45%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          direction: i18n.resolvedLanguage === "en" ? "" : "rtl",
        }}
      >
        <div
          ref={textRef}
          dangerouslySetInnerHTML={{ __html: highlightedText }}
          style={{
            fontSize: 16,
            paddingBottom: 25,
            textAlign: "center",
            direction: i18n.resolvedLanguage === "en" ? "" : "rtl",
            //i18n.language
          }}
        />

        <a style={{ fontSize: 16, paddingBottom: 8 }}>
          {i18n.language === "en"
            ? TheObject.disc2
            : i18n.language === "ar"
            ? TheObject.disc2Ar
            : i18n.language === "he"
            ? TheObject.disc2He
            : TheObject.disc2}
        </a>
        <a style={{ fontSize: 16 }}>
          {i18n.language === "en"
            ? TheObject.disc3
            : i18n.language === "ar"
            ? TheObject.disc3Ar
            : i18n.language === "he"
            ? TheObject.disc3He
            : TheObject.disc3}
        </a>
        {isAfter ? (
          <>
            <a style={{ fontSize: 14, paddingTop: 25, color: "red" }}>
              {t("profile.Specialofferwillendin")} <a ref={displayRef}></a>
            </a>
          </>
        ) : (
          <>
            <a style={{ fontSize: 14, paddingTop: 25, color: "red" }}>
              Special offer is over {TheObject.dateEnd}
            </a>
          </>
        )}
      </div>
    </div>
  );
}
